var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import { Decorator } from '../decorator';
export var TextArea = React.forwardRef(function Input(_a, ref) {
    var hint = _a.hint, label = _a.label, error = _a.error, errorMessage = _a.errorMessage, id = _a.id, fieldError = _a.fieldError, requiredIndicator = _a.requiredIndicator, className = _a.className, append = _a.append, prepend = _a.prepend, rest = __rest(_a, ["hint", "label", "error", "errorMessage", "id", "fieldError", "requiredIndicator", "className", "append", "prepend"]);
    var isError = !!(error || errorMessage || fieldError);
    return (React.createElement(Decorator, { id: id, className: className, error: error, errorMessage: errorMessage, label: label, hint: hint, fieldError: fieldError, requiredIndicator: requiredIndicator },
        React.createElement("div", { className: classNames("relative rounded shadow-sm flex flex-col gap-3 px-3 py-2.5 sm:py-2 ring-1 ring-inset focus-within:shadow-md", {
                "ring-error-300 focus-within:shadow-error-100 focus-within:ring-error-300": isError,
                "ring-gray-300 focus-within:shadow-primary-100 focus-within:ring-primary-300": !isError,
                "bg-gray-50 text-gray-500": rest.disabled,
                "bg-white": !rest.disabled
            }) },
            prepend,
            React.createElement("textarea", __assign({ className: classNames("block flex-1 rounded border-0 p-0 text-gray-900 bg-transparent text-base placeholder:text-gray-500 ring-0 focus:ring-0 no-resize resize-none"), id: id, ref: ref }, rest)),
            append)));
});
